import { useRef, useState } from 'react';
import {
    BrowserRouter,
    Route,
    Routes
} from "react-router-dom";

export default function Index(props) {
    const inputRef = useRef(null);
    const [value, setValue] = useState(0);

    return (
		<div class="text-center my-4">کاربر گرامی شما در تاریخ {new Date().toLocaleDateString('fa')} وارد سیستم شدید.</div>
    );
}
